import * as React from "react";
import { SVGProps } from "react";
const SvgRadioCheckboxRing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#radio-checkbox-ring_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 2c7.7 0 14 6.3 14 14s-6.3 14-14 14S2 23.7 2 16C2 8.404 8.13 2.17 15.689 2.003L16 2Zm0-2C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="radio-checkbox-ring_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRadioCheckboxRing;
